import I18n from 'hooks/useI18n';
import { useRouter } from 'hooks/useRouter';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Modal, { IModalComponentProps } from '../Modal/Modal';

import ScrollPickerBirthday from 'components/ScrollPickerDate';
import MemberButton from 'components/common/buttons/MemberButton';

import ButtonGroup from 'components/common/buttons/ButtonGroup';
import useSelectorWebUtils from 'functions/useSelectorWebUtils';
import { COUPLE_TYPE, DATE_FORMAT } from 'redhotpie-shared-lib/constants/constants';
import HeaderMember from '../../Header/HeaderMember';
import './styles.scss';

interface AgeModalProps extends IModalComponentProps {
  ageInfo: any;
  onClickDone: any;
  showModal: any;
  idTabSelected: any;
  headerText?: string;
}

interface ISexual {
  id: number;
  label: string;
  isSelected: boolean;
}
const AgeModal = (props: AgeModalProps) => {
  const { ageInfo, onClickDone, showModal, idTabSelected } = props;
  const { history, location } = useRouter();
  const refModal = useRef<Modal>(null);
  const dateDefaultValue = moment().subtract('19', 'years').toJSON();

  const { generateAge } = useSelectorWebUtils();

  const [birthdate, setBirthDate] = useState('');
  const [birthdate2, setBirthDate2] = useState('');
  const [dataSexual, setDataSexual] = useState<ISexual[]>([]);
  const [isCouple, setCouple] = useState(false);
  const [birthDateRender, setBirthDateRender] = useState<string>(dateDefaultValue);

  const keyCheckSexual = useMemo(() => {
    return dataSexual.findIndex(item => item.isSelected) + 1;
  }, [dataSexual]);

  const yo = useMemo(() => {
    return generateAge(birthDateRender);
  }, [birthDateRender, generateAge]);

  useEffect(() => {
    setDataSexual([
      {
        id: 1,
        label: 'Him',
        isSelected: idTabSelected === COUPLE_TYPE.HIM,
      },
      {
        id: 2,
        label: 'Her',
        isSelected: idTabSelected === COUPLE_TYPE.HER,
      },
    ]);
  }, [idTabSelected]);

  useEffect(() => {
    if (!showModal) {
      onChangeButtonGroup(0);
      setCouple(false);
      setBirthDate('');
      setBirthDate2('');
    } else {
      let birthRender = ageInfo?.birthdate;
      if (idTabSelected === COUPLE_TYPE.HER) {
        birthRender = ageInfo?.birthdate2;
      }
      setBirthDateRender(birthRender === DATE_FORMAT.TYPE_1 ? dateDefaultValue : moment(birthRender || dateDefaultValue).toJSON());
      setBirthDate(ageInfo?.birthdate === DATE_FORMAT.TYPE_1 ? dateDefaultValue : moment(ageInfo?.birthdate || dateDefaultValue).toJSON());
      setBirthDate2(
        ageInfo?.birthdate2 === DATE_FORMAT.TYPE_1 ? dateDefaultValue : moment(ageInfo?.birthdate2 || dateDefaultValue).toJSON()
      );
      setCouple(!!ageInfo?.birthdate2);
    }
  }, [showModal]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (birthDateRender) {
      console.log(moment(birthDateRender).date());
      console.log(moment(birthDateRender).format('MMM'));
      console.log(moment(birthDateRender).year());
    }
  }, [birthDateRender]);

  function closeModal(cb?: () => void) {
    refModal.current?.closeModal(cb);
  }

  const handleClickDone = useCallback(() => {
    closeModal(() => {
      const params: any = {
        birthdate: birthdate === DATE_FORMAT.TYPE_1 ? dateDefaultValue : birthdate,
        birthdate2: '',
      };
      if (isCouple) {
        params.birthdate2 = birthdate2 === DATE_FORMAT.TYPE_1 ? dateDefaultValue : birthdate2;
      }
      if (onClickDone) {
        onClickDone(params);
      }
    });
  }, [birthdate, birthdate2, isCouple, onClickDone, dateDefaultValue]);

  const onChangeButtonGroup = useCallback(
    (index: number) => {
      if (dataSexual.length > 0) {
        setDataSexual(prev => prev.map((item, idx) => ({ ...item, isSelected: index === idx })));
        if (index === 0) {
          setBirthDateRender(birthdate || dateDefaultValue);
        } else {
          setBirthDateRender(birthdate2 || dateDefaultValue);
        }
      }
    },
    [dataSexual, birthdate, birthdate2, dateDefaultValue]
  );

  const onChangeBirthDate = useCallback(
    (time: any) => {
      if (dataSexual.length > 0 && time && time !== 'Invalid date') {
        const itemSelect = dataSexual.find(data => data.isSelected);
        if (itemSelect?.id === 1) {
          setBirthDate(time);
        } else {
          setBirthDate2(time);
        }
        setBirthDateRender(time);
      }
    },
    [dataSexual]
  );

  function renderPopup() {
    return (
      <div className="age-wrapper">
        <div className="age-header">
          <HeaderMember
            txtLeft={I18n.t('Btn.Cancel')}
            onClickLeftIcon={() => closeModal()}
            txtRight={I18n.t('Btn.Done')}
            onClickRightIcon={handleClickDone}
            disableIcLeft
            textHeader={I18n.t('LookingToMeetScreen.Age')}
          />
          {isCouple && <ButtonGroup items={dataSexual} singleSelect className="btn-group-sexual" onSelect={onChangeButtonGroup} />}
          <span>{I18n.t('EditProfile.WhatIsYourDate')}</span>
        </div>
        <div className="age-yo">
          <span>{I18n.t('EditProfile.Age')}</span>
          <span>{yo}</span>
        </div>
        <ScrollPickerBirthday
          userSelectedDay={moment(birthDateRender).date()}
          userSelectedMonth={moment(birthDateRender).format('MMM')}
          userSelectedYear={moment(birthDateRender).year()}
          onChange={onChangeBirthDate}
          keyCheckSexual={keyCheckSexual}
        />
        <MemberButton text={I18n.t('Btn.Done')} onClick={handleClickDone} color="primary" />
      </div>
    );
  }

  return (
    <Modal
      {...props}
      ref={refModal}
      modalName="AgeModal"
      childHook={renderPopup}
      history={history}
      location={location}
      showModal={props.showModal || false}
      headerText={props.headerText}
    />
  );
};

export default AgeModal;
